import { createContext, useContext } from "react";

const AccessContext = createContext(false);

export const AccessProvider = ({ isLoaded, hasToken, children }) => (
  <AccessContext.Provider value={{ isLoaded, hasToken }}>
    {children}
  </AccessContext.Provider>
);

export const useAccessLoaded = () => useContext(AccessContext);
export const useAccessContext = () => useContext(AccessContext);
